import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const BackgroundImage = styled(GatsbyImage)` 
  position: absolute;
  width: 100%;
  height: 100%;
`;

const slidesWrap = styled.div`
  max-width: 52rem;
  text-align: left; 
  
  h3 {
      @media (max-width: 1024px) { 
          text-align: center;
          display: flex;
          justify-content: center;
      }
  }

  @media (max-width: 1024px) { 
      max-width: none;
      text-align: center;
  }
`;

const slideButton = styled.a`
  @media (max-width: 1024px) { 
    display: inline-block;
    margin: 0 auto;
    margin-top: 2em;
  }
`;

const S = {
    BackgroundImage,
    slidesWrap,
    slideButton
};

export default S;
